import { PositiveDirection } from '@legacy-modules/metrics2/models/entities/PositiveDirection';

import ValueExpression from '@legacy-modules/valueexpressions/models/valueexpressions/ValueExpression';

export default new ValueExpression({
  identifier: 'lma-anomalies.hr.zustelltag.count',
  label: 'Tagversetzte Bearbeitung',
  positiveDirection: PositiveDirection.custom,
});
